export default {
	label: "",
	isVisible: true,
};
